export function handleDismissAlertClick(button, alertCount) {
  button.fadeOut(300);

  checkAlerts(alertCount);
}

export function handleAcceptMentorInviteClick($anchor, alertId, alertCount) {
  $.get("index.php/goaltab3/alerts/mark_as_read/" + alertId);

  $anchor.text('Invitation Accepted');
  $anchor.removeClass('btn btn--secondary').addClass('text-light');
  $anchor.css('pointer-events', 'none');
  $anchor.parent('div').addClass('align-items-center');

  checkAlerts(alertCount);
}

export function handleAddStandardClick($anchor, alertId, alertCount) {
  $.get("index.php/goaltab3/alerts/mark_as_read/" + alertId);

  $anchor.text('Standard Added');
  $anchor.removeClass('btn btn--secondary').addClass('text-light');
  $anchor.css('pointer-events', 'none');
  $anchor.parent('div').addClass('align-items-center');

  const $standardAddedAlert = $('.standard-added-alert');
  $standardAddedAlert.removeClass('d-none');

  checkAlerts(alertCount);
}

function checkAlerts(count) {
  if (count < 1) {
    $('#alertBtn').removeClass('notification-available');
  }
}